import { Base } from "../../framework/base";
import { EditItem, IEditItem } from "../common/editItem";
import { EnumHelper, InstantMessageChannelUserActiveState, InstantMessageChannelUserType } from "../enums";

export interface IInstantMessageChannelEditUserItem extends IEditItem {
    companyId: string;
    userType: InstantMessageChannelUserType;
    userCode: string;
    firstName: string;
    lastName: string;
    picture: string;
    activeState: InstantMessageChannelUserActiveState;

    getName(): string;
    getIsInvited(): boolean;
    getIsActive(): boolean;
    getIsRejected();
}

export class InstantMessageChannelEditUserItem extends EditItem implements IInstantMessageChannelEditUserItem {
    companyId: string;
    userType: InstantMessageChannelUserType;
    userCode: string;
    firstName: string;
    lastName: string;
    picture: string;
    activeState: InstantMessageChannelUserActiveState;

    constructor();
    constructor(obj: IInstantMessageChannelEditUserItem);
    constructor(obj?: any) {
        super(obj);
        this.companyId = obj && obj.companyId || "";
        this.userType = obj && obj.userType || InstantMessageChannelUserType.User;
        this.userCode = obj && obj.userCode || "";
        this.firstName = obj && obj.firstName || "";
        this.lastName = obj && obj.lastName || "";
        this.picture = obj && obj.picture || "";
        this.activeState = obj && obj.activeState || InstantMessageChannelUserActiveState.Rejected;
    }

    getName(): string {
        return ((this.lastName ?? "") + " " + (this.firstName ?? "")).trim();
    }

    getHash(): string {
        return super.getHash() + "#" + (this.companyId ?? "") + "#" + this.userType.toString(10) + "#" + this.activeState.toString(10);
    }

    getIsInvited(): boolean {
        return EnumHelper.isEqual(this.activeState, InstantMessageChannelUserActiveState.Invited);
    }
    
    getIsActive(): boolean {
        return EnumHelper.isEqual(this.activeState, InstantMessageChannelUserActiveState.Active);
    }
    
    getIsRejected(): boolean {
        return EnumHelper.isEqual(this.activeState, InstantMessageChannelUserActiveState.Rejected);
    }
    
    static sortInstantMessageChannelEditUserItems(items: IInstantMessageChannelEditUserItem[], column: string, asc: boolean): IInstantMessageChannelEditUserItem[] {
        if (!items && items.length < 2) return items;
        if (column === "userType") {
            return items.sort((a: IInstantMessageChannelEditUserItem, b: IInstantMessageChannelEditUserItem) => { return (!a || !b) ? 0 : ((asc ? 1 : -1) * Base.numCompare(a.userType, b.userType)); });
        } else if (column === "userCode") {
            return items.sort((a: IInstantMessageChannelEditUserItem, b: IInstantMessageChannelEditUserItem) => { return (!a || !b) ? 0 : ((asc ? 1 : -1) * Base.strCompare(a.userCode, b.userCode)); });
        } else if (column === "activeState") {
            return items.sort((a: IInstantMessageChannelEditUserItem, b: IInstantMessageChannelEditUserItem) => { return (!a || !b) ? 0 : ((asc ? 1 : -1) * Base.numCompare(a.activeState, b.activeState)); });
        } else {
            return items.sort((a: IInstantMessageChannelEditUserItem, b: IInstantMessageChannelEditUserItem) => { return (!a || !b) ? 0 : ((asc ? 1 : -1) * Base.strCompare(a.getName(), b.getName())); });
        }
    }
}